import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Row, Col, Icon, Typography, Button } from 'antd';

export class DefaultPage extends Component {
  static propTypes = {
    acessoNegado: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    return (
      <div className="acesso-negado-default-page">
        <div className="containerPage" >
          <div className="containerConteudo">
            <Row type="flex" justify="space-around" align="middle">
              <Col md={8} style={{textAlign: 'center'}}>
                <Icon type="eye-invisible" style={{ fontSize: '130px' }}/>
              </Col>
              <Col md={16}>
                <Row type="flex" justify="space-around" align="middle">
                  <Col md={24} style={{marginBottom: '15px'}}>
                    <Typography.Title level={3}>Acesso negado! Entre em contato com um administrador do sistema.</Typography.Title>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Button onClick={ e=> window.location = '/signout'} >
            <Icon type="logout" /> Sair
          </Button>
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    acessoNegado: state.acessoNegado,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DefaultPage);



// WEBPACK FOOTER //
// ./src/features/acesso-negado/DefaultPage.js